// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const EvidenceOut = zod.object({
  "id": zod.string(),
  "kind": zod.enum(['section', 'metric']),
  "label": zod.union([zod.string(),zod.null()]).optional(),
  "provenance": zod.union([zod.string(),zod.null()]).optional(),
  "quote": zod.string()
});

export type EvidenceOut = zod.input<typeof EvidenceOut>;
export type EvidenceOutOutput = zod.output<typeof EvidenceOut>;
